import React, { useState, useRef, useEffect } from 'react';
import './index.module.less';

import NavBar from '@components/NavBar';
import AnimationView from './AnimationView';
import PhonePanel, { TPhonePanelItem } from '@views/sections/PhonePanel';
import EditPhoneMenu from '@views/sections/EditPhoneMenu';
import { CacheEditPhoneDataKey, TConfig } from '@views/modules/device/EditPhoneEntry';

import { Api } from '@apis/client';
import Http from '@helpers/Http';
import Filter from '@helpers/Filter';
import BrowserHistory from '@helpers/BrowserHistory';
import * as Cache from '@helpers/Cache';
import { TUser } from '@apis/gloabal';
import Toast from '@widgets/Toast';

const getUpdateUsers = (users: TUser[]) => {
  const result: TUser[] = [];
  Array.from({length: 3}).forEach((item, index: number) => {
    const user = users[index];
    if (user) {
      result.push(user);
    } else {
      result.push({
        uid: '',
        phone: '',
        headImageUrl: '',
        name: '',
        index: 0,
        isAdmin: false,
        userUid: '',
      })
    }
  })
  return result;
}

const SosPhoneSetting = () => {
  const configRef = useRef<TConfig>();
  const params = useRef(Filter.urlParams(window.location.search));
  const deviceType = params.current.version || '1';
  const [showPopMenu, setShowPopMenu] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState<number>();
  const [users, setUsers] = useState<TUser[]>(getUpdateUsers([]));

  useEffect(() => {
    init();
  }, [])

  const init = async () => {
    const result = await Http.post(Api.GetSosConfig,
      { snCode: params.current.sncode, company: params.current.company }
    );
    if(result) {
      const config: TConfig = result.data || {
        company: params.current.company,
        snCode: params.current.sncode,
        users: []
      };
      configRef.current = config;
      setUsers(getUpdateUsers(config.users));
    }
  }

  const onClickItem = (item: TPhonePanelItem, index: number) => {
    setSelectedIndex(index);
    if (item && item.phone) {
      setShowPopMenu(true);
    } else {
      toEditPhonePage(index);
    }
  }

  const onDelete = async () => {
    const data = {
      snCode: params.current.sncode,
      company: params.current.company,
      users: [...users].filter((item, index: number) => index !== selectedIndex && !!item.phone),
    }
    const result = await Http.post( Api.PostSosConfig, data);
    if(result) {
      Toast.show({
        title: '删除成功',
        type: 'strip'
      });
      init();
    }
  }

  const onEdit = () => {
    toEditPhonePage(selectedIndex);
  }

  const toEditPhonePage = (index: number) => {
    Cache.save(CacheEditPhoneDataKey, {
      type: 'sosPhone',
      selectedIndex: index,
      config: {
        ...configRef.current,
        users: users
      }
    });
    BrowserHistory.push(`${PUBLIC_URL}/editphoneentry?sncode=${params.current.sncode}&company=${params.current.company}`);
  }
  
  return (
    <div styleName="container">
      <NavBar
        title="SOS求助设置"
      />
      <AnimationView type={deviceType} />

      <div styleName="wrapper">
        <div styleName="tip-text">{`紧急联系人(${configRef.current?.users.length || 0}/3)`}</div>

        <PhonePanel data={users} onClick={onClickItem} />

        <div styleName="tip-text">长按SOS键可进行紧急求助，求助时会按照以上顺序轮流拨打求助号码，至接听为止（此功能需要SIM卡）。</div>
      </div>

      {
        showPopMenu ? (
          <EditPhoneMenu
            onClose={ () => setShowPopMenu(false) }
            onDelete={onDelete}
            onEdit={onEdit}
          />
        ) : null
      }
    </div>
  )
}

export default SosPhoneSetting;
